/**
 * Створює тимчасове посилання та імітує клік для завантаження файлу.
 * @param {Blob} blob - Файл (Blob) для завантаження.
 * @param {string} filename - Бажане ім'я файлу.
 */
export const downloadFile = (blob, filename) => {
  // Створюємо URL для Blob'a
  const url = window.URL.createObjectURL(blob);

  // Створюємо тимчасовий елемент <a>
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  a.download = filename;

  // Додаємо посилання в DOM, клікаємо і видаляємо
  document.body.appendChild(a);
  a.click();

  // Очищуємо
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};
